import BrandLogo from "../../../utils/brands/BrandLogo.jsx";
import {isAdministratorOnlyBrand} from "../../../utils/brands/brandVisibility.js";
import SuperadminIndicator from "../../../components/auth/SuperadminIndicator.jsx";

export default function CreateIntegrationPlatform({brand, onClick}) {
    const administratorOnly = isAdministratorOnlyBrand(brand);

    return <div
        className={'comp__roundedBox relative flex h-32 w-36 flex-col items-center justify-center gap-3 select-none rounded !border !border-transparent bg-white px-3 py-2 shadow cursor-pointer transition-colors hover:!border-violet-500 hover:!bg-white dark:bg-slate-800 dark:hover:!border-violet-400 dark:hover:!bg-slate-800'}
        onClick={onClick}
    >
        {administratorOnly && <SuperadminIndicator className={'absolute right-2 top-2 !h-6 !w-6'}/>}
        <BrandLogo brand={brand}
            className={'shrink-0 !my-0'}
            size={10}
        />
        <div className={'text-center text-base font-medium leading-tight break-words'}>{brand['name']}</div>
    </div>;
}
